import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { PasswordRecoverComponent } from './password-recover.component';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('registration.password-recover', {
            url: '/password-recover/:token',
            ncyBreadcrumb: {
                label: 'Ripristino Password'
                //                            parent: 'Ri'
            },
            params: {
                token: ''
            },
            data: {
                authorisationLevel: 0,
                pageTitle: 'Password Recover'
            },
            'views': {
                'multiContentRegistration': {
                    template: '<password-recover flex="100"></password-recover>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const PasswordRecoverModule: string = ng
    .module('password-recover', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('passwordRecover', PasswordRecoverComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/password-recover/password-recover.module.ts